import React, { useEffect, useState } from "react";
import { Collapse, Divider } from "@mui/material";
import { SmartContainer } from "../../../styles/Containers";
import { StyledList, StyledListItem, StyledListItemIcon, StyledListItemText } from "../../../styles/matieralui/List";
import { IconPhotoAlbum, IconPhotoLibrary } from "../../Icons";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import styled from "styled-components";
import { FullLibraries } from "../Library/redux/library.selectors";
import { useDispatch } from "react-redux";
import { useMyPermissions } from "../Permission/redux/permissions.actions";
import { Role } from "../../../redux/Auth/auth.selectors";
import { searchLibrary } from "../Library/redux/library.actions";
import { FullAlbums } from './redux/album.selectors';
import { searchAlbum } from "./redux/album.actions";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const StyledItem = styled(StyledListItem)`
    .MuiTypography-root {
        font-size: 0.75em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .MuiSvgIcon-root {
        width: 0.75em;
        height: 0.75em;
    }
`

const StyledSubList = styled(StyledList)`
    margin-left: 1.5em !important;
    .MuiTypography-root {
        opacity: 0.75;
    }
`

const StyledFolders = styled(SmartContainer)`
    /* max-height: 300px;
    overflow: scroll; */
`

export const FolderLibrary = ({ library, refresh = false }) => {
    const dispatch = useDispatch();
    const store = FullAlbums();
    const { id, albumId } = useParams();
    const key = `FoldersAlbum_${library.id}`;
    const albumFilters = { LibraryId: `["${library.id}"]` };

    const [openFolders, setOpenFolders] = useState(false);

    const loadAlbums = () => {
        const args = { ...albumFilters };
        args.prefix = key;
        args.order = `[["name", "ASC"]]`;
        dispatch(searchAlbum(0, null, null, null, args))
    }

    useEffect(() => {

        // Load on Open
        if (!store[key] && openFolders == true) {
            loadAlbums();
        }

    }, [library?.id, openFolders]);

    useEffect(() => {
        // refresh data for all data we have

        if (refresh !== true) return;
        if (store[key]) {
            loadAlbums();
        }
    }, [refresh])

    useEffect(() => {
        if (id === library?.id) setOpenFolders(true)
    }, [id, library?.id])

    const go = (album) => dispatch(push(`/library/${library.id}/album/${album.id}`))
    const goToRecent = () => dispatch(push(`/library/${library.id}`))

    const selected = (id === library?.id) ? true : false;

    return (
        <SmartContainer>
            <StyledItem button onClick={(e) => setOpenFolders(!openFolders)}>
                {/* <StyledListItemIcon><IconPhotoLibrary /></StyledListItemIcon> */}
                {openFolders ? <ExpandMore /> : <KeyboardArrowRightIcon />}
                <StyledListItemText>{library?.name}</StyledListItemText>
            </StyledItem>
            <Collapse in={openFolders} timeout="auto" unmountOnExit>

                {store[`${key}Loading`] !== true && (
                    <StyledSubList component="div" disablePadding>
                        <StyledItem button onClick={() => goToRecent()}>
                            <StyledListItemText>Recent Uploads</StyledListItemText>
                        </StyledItem>
                    </StyledSubList>
                )}
                {store[`${key}Loading`] === true && (
                    <StyledSubList component="div" disablePadding>
                        <StyledItem button>
                            <StyledListItemText>Loading...</StyledListItemText>
                        </StyledItem>
                    </StyledSubList>
                )}
                {store[`${key}Loading`] !== true && store[key]?.count > 0 && (
                    <StyledSubList component="div" disablePadding>
                        {store[key]?.rows?.map(i => (
                            <StyledItem button onClick={() => go(i)} selected={(albumId === i.id)}>
                                <StyledListItemText>{i?.name}</StyledListItemText>
                            </StyledItem>
                        ))}
                    </StyledSubList>
                )}
            </Collapse>
        </SmartContainer >
    )
}


export const Folders = ({ refresh = false }) => {
    const dispatch = useDispatch();
    const store = FullLibraries();
    const currentUserRole = Role();
    const [filters, setFilters] = useState(null);
    const [permChecked, setPermChecked] = useState(false);
    const { permissions, getFiltersBasedOnMyPermission } = useMyPermissions();


    // Permissions: Only My Libraries
    useEffect(() => {

        if (currentUserRole !== 'owner' && currentUserRole !== 'admin' && permissions) {
            const f = getFiltersBasedOnMyPermission('Library');
            if (!f) return; // There are no permission for views found for this user
            setFilters({ id: f });
            setPermChecked(true);
        } else {
            setPermChecked(true); // Set to True as you are an admin or owner.
        }

    }, [permissions])

    const loadLibraries = () => {
        const args = { ...filters };
        args.prefix = 'FoldersLibraries';
        dispatch(searchLibrary(0, null, null, null, args))
    }

    const runLoadLibraries = () => {

    }

    useEffect(() => {

        // Wait Until the permissions are checked.
        if (permChecked !== true) return;

        // If we already have the data don't call it again
        if (store?.FoldersLibraries?.count > 0) return;

        // If there are no Filters & you Aren't an admin or owner... Wait until there are filters.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin' && !filters) return;

        // If loading.. wait
        if (store?.FoldersLibrariesLoading === true) return;

        // Load the Libraries
        loadLibraries();

    }, [filters, permChecked])

    useEffect(() => {

        if (refresh !== true) return;

        // Wait Until the permissions are checked.
        if (permChecked !== true) return;

        // If there are no Filters & you Aren't an admin or owner... Wait until there are filters.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin' && !filters) return;

        // If loading.. wait
        if (store?.FoldersLibrariesLoading === true) return;

        // Load the Libraries
        loadLibraries();

    }, [refresh])


    // Get All Albums with Libraries.
    if (!store?.FoldersLibraries) return null;



    return (
        <StyledList>

            <StyledFolders>
                {store?.FoldersLibraries?.rows?.map(lib => (<FolderLibrary library={lib} refresh={refresh} />))}
            </StyledFolders>

        </StyledList>
    )
}

// {open ? <ExpandLess /> : <ExpandMore />}
// </ListItemButton>
// <Collapse in={open} timeout="auto" unmountOnExit>
//   <List component="div" disablePadding>
//     <ListItemButton sx={{ pl: 4 }}>
//       <ListItemIcon>
//         <StarBorder />
//       </ListItemIcon>
//       <ListItemText primary="Starred" />
//     </ListItemButton>
//   </List>
// </Collapse>